module.exports = __webpack_public_path__ + "static/img/per11.97a1db4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per11.jpg
// module id = MeBI
// module chunks = 41